import { DeviceComponent, PartsComponent } from "./components";

export function DeviceInformationForm() {
  return <></>;
}

DeviceInformationForm.Device = DeviceComponent;
DeviceInformationForm.Parts = PartsComponent;
